import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledDrawerFooterDiv = styled.div``

const DrawerFooter = ({children, ...otherProps}) => <StyledDrawerFooterDiv {...otherProps}>{children}</StyledDrawerFooterDiv>

DrawerFooter.propTypes = {
  children: PropTypes.any
}

export {DrawerFooter}
